import { useSearchParams, useNavigate } from "react-router-dom";
import { AccountConfirmedPageTemplateProps } from "./template";
import { useResendSignUp } from "@auth";
import { useState } from "react";
import { toast } from "sonner";

export const useAccountConfirmedPage = (): AccountConfirmedPageTemplateProps => {
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const email = searchParams.get('email');
    const navigate = useNavigate();
    const resendSignUp = useResendSignUp();

    const handleSignInClick = () => {
        navigate("/signin");
    }

    const handleResendEmailClick = async () => {
        console.log("code", code);
        console.log("email", email);
        setIsLoading(true);
        if (email) {
            try {
                await resendSignUp(email);
                toast.success("Confirmation email sent successfully!", {
                    description: `You just resent the verification email at ${email}. Please check your inbox for the new confirmation email.`,
                    duration: 2000,
                });
            } catch (error) {
                toast.error("Failed to send confirmation email", {
                    description: "Please try again later or contact support if the issue persists.",
                    duration: 2000,
                });
            } finally {
                setIsLoading(false);
            }
        }
    }

    return {
        code,
        handleSignInClick,
        handleResendEmailClick,
        isLoading,
    }
}